import { render, staticRenderFns } from "./ProcedureChoice.vue?vue&type=template&id=6191739e"
import script from "./ProcedureChoice.vue?vue&type=script&lang=js"
export * from "./ProcedureChoice.vue?vue&type=script&lang=js"
import style0 from "./ProcedureChoice.vue?vue&type=style&index=0&id=6191739e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports